export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const EMAIL = 'b.paxton@andersenlab.com';
export const PHONE = '+1 910 916 4176';

export const MEETUP_DATE = '2025-12-04';
export const MEETUP_TIME = '5:30 PM CST';
